import { defineMessages } from 'react-intl';

export const nativeEmbedBlockMenuMessages: {
	copy: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	copy: {
		id: 'editor-plugin-native-embeds.messages.block-menu.copy',
		defaultMessage: 'Copy',
		description: 'Copy the selected content to the clipboard',
	},
});
